// ── B-F2 — ¿HAY UNA SESIÓN DE ESTUDIO EN PANTALLA? ──────────────────────────
//
// El registro de OCUPACIÓN de las tres pantallas de estudio. Existe por una sola
// razón: `AuthContext` necesita esa respuesta desde un handler que se registra
// UNA vez, fuera de React y —lo decisivo— FUERA DEL ROUTER (`AuthProvider`
// envuelve a `BrowserRouter`, App.js:284-296), así que ni `useLocation` ni
// ningún estado de pantalla le llegan nunca. Es el mismo patrón que
// `registerSessionExpiredHandler` (lib/api.js), que ya cruza esta misma frontera
// en la dirección contraria; aquí sólo se cruza de vuelta.
//
// ── POR QUÉ MONTAJE Y NO EL CANDADO DEL EXAMEN ──────────────────────────────
//
// El candidato obvio era `isExamActive` (contexts/ExamContext.js), que ya es una
// señal única para las tres superficies. NO SIRVE, y la razón es exacta: ese
// candado responde «¿hay una sesión EN CURSO que no te deja navegar?» y se APAGA
// al terminar —examen entregado (ExamSimulator.js:1508 y :961), adaptiva con
// `finished` (AdaptiveStudy.js:95), flashcards con `showSummary`/`allMastered`
// (Flashcards.js:413)—, o sea que estaría en `false` justo mientras el usuario
// lee sus resultados. Colgar la aplicación de ahí lo expulsaría del acta final,
// que es precisamente lo que la firma prohíbe: ver resultados cuenta como
// TODAVÍA ADENTRO.
//
// La pregunta de aquí es otra: «¿el usuario sigue dentro de la actividad?».
// Montaje/desmontaje de la pantalla la contesta entera, y es la única señal que
// ya es SIMÉTRICA POR CONSTRUCCIÓN: el `return` del efecto ES la salida, así que
// las dos mitades —la que pospone y la que aplica— no pueden divergir. Además es
// homogénea de verdad: una sola llamada idéntica en las tres pantallas, sin
// depender del estado de sesión de cada una (que se llama distinto en cada
// archivo y significa cosas distintas).
//
// CERO timers y CERO listeners: dos variables de módulo y tres funciones puras.

export const STUDY_SCREEN = {
  EXAM: 'exam',
  ADAPTIVE: 'adaptive',
  FLASHCARDS: 'flashcards',
};

// Qué pantalla de estudio está montada AHORA, o `null`. Un solo hueco y no un
// contador: las tres son rutas hermanas bajo el mismo `<Routes>`, así que jamás
// coexisten. React corre TODAS las limpiezas de un commit antes que los efectos
// nuevos, de modo que en un cambio de ruta la salida de la vieja siempre precede
// a la entrada de la nueva.
let ocupada = null;

// Quién se entera de la salida. Uno solo, como el de sesión expirada: hay un
// `AuthProvider` por árbol.
let alSalir = null;

/** La respuesta a «¿hay sesión de estudio en pantalla?»: el nombre, o `null`. */
export function getStudyScreen() {
  return ocupada;
}

/**
 * Registra a quien quiera enterarse de que el usuario ABANDONÓ la pantalla de
 * estudio. `null` lo da de baja (desmontaje del provider).
 */
export function registerStudyExitHandler(handler) {
  alSalir = handler;
}

export function enterStudyScreen(pantalla) {
  ocupada = pantalla;
}

export function leaveStudyScreen(pantalla) {
  // La guardia cubre el caso en que otra pantalla ya reclamó el hueco: entonces
  // esto no es una salida de la actividad, es una limpieza atrasada, y avisar
  // aplicaría la expiración con el usuario todavía estudiando.
  if (ocupada !== pantalla) return;
  ocupada = null;
  if (alSalir) alSalir(pantalla);
}

/** Solo para tests: deja el registro como recién cargado el módulo. */
export function __resetStudyPresenceForTests() {
  ocupada = null;
  alSalir = null;
}
